import React, { useEffect, useState } from "react";
import "../styles/Register.css";
import { db } from "../firebase";
import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  doc,
  updateDoc,
} from "firebase/firestore";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable"; // ✅ Import the plugin
import {  query, where,} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";



const Register = () => {
 const [formData, setFormData] = useState({
  name: "",
  hid: "",
  // registerDate: "",
  // endDate: "",
  // dur: "",
  // dob: "",
  // age: "",
  // address: "",
  phone: "",
  // department: "",
  // designation: "",
  // education: "",
  // jObroll:"",
  room:"",
  broom:"",
  mail: [], // ✅ Now it's an array
  imageUrl: "", // Will store uploaded image URL
});


  const [employees, setEmployees] = useState([]);
  const [search, setSearch] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [editId, setEditId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  // const totalPages = 15;
  const itemsPerPage = 7; // or 10 or any number of items per page
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const [newEmail, setNewEmail] = useState("");

  // const [shownBirthdays, setShownBirthdays] = useState([]);


  const fetchEmployees = async () => {
    const querySnapshot = await getDocs(collection(db, "employees"));
    const data = querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
    setEmployees(data);
  };

  useEffect(() => {
    fetchEmployees();
  }, []);

//  const calculateDuration = (start, end) => {
//   if (!start || !end) return "";

//   const startDate = new Date(start);
//   const endDate = new Date(end);

//   if (isNaN(startDate) || isNaN(endDate)) return "";

//   let years = endDate.getFullYear() - startDate.getFullYear();
//   let months = endDate.getMonth() - startDate.getMonth();
//   let days = endDate.getDate() - startDate.getDate();

//   // Adjust if day difference is negative
//   if (days < 0) {
//     months -= 1;
//     const prevMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 0);
//     days += prevMonth.getDate(); // get days in previous month
//   }

//   // Adjust if month difference is negative
//   if (months < 0) {
//     years -= 1;
//     months += 12;
//   }

//   return `${years} year(s), ${months} month(s), ${days} day(s)`;
// };


const handleInputChange = (e) => {
  const { name, value } = e.target;

  if (name === "dob") {
    const birthDate = new Date(value);
    const ageDifMs = Date.now() - birthDate.getTime();
    const ageDate = new Date(ageDifMs);
    const age = Math.abs(ageDate.getUTCFullYear() - 1970);
    setFormData((prev) => ({ ...prev, dob: value, age }));
  } else {
    setFormData((prev) => {
      const updatedForm = { ...prev, [name]: value };

      // Calculate duration if registerDate or endDate changed
      // if (name === "registerDate" || name === "endDate") {
      //   updatedForm.dur = calculateDuration(
      //     updatedForm.registerDate,
      //     updatedForm.endDate
      //   );
      // }

      return updatedForm;
    });
  }
};

const handleImageUpload = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const storage = getStorage();
  const storageRef = ref(storage, `employeeImages/${Date.now()}_${file.name}`);
  
  try {
    await uploadBytes(storageRef, file);
    const url = await getDownloadURL(storageRef);
    setFormData((prev) => ({ ...prev, imageUrl: url }));
  } catch (error) {
    console.error("Image upload failed:", error);
    alert("Failed to upload image");
  }
};

 const handleRegister = async (e) => {
  e.preventDefault();

  try {
    if (editId) {
      // Update mode - skip duplicate check
      await updateDoc(doc(db, "employees", editId), formData);
      setEditId(null);
      alert("updated successfully");  // <-- alert for update
    } else {
      // Duplicate check only for new entries
      const q = query(collection(db, "employees"), where("epfOrPid", "==", formData.hid));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        alert("Hotel with this HID already exists.");
        return;
      }

      // Add new document
      await addDoc(collection(db, "employees"), formData);
      alert("registered successfully");  // <-- alert for new registration
    }

    // Clear form
    setFormData({
      name: "",
      hid: "",
      // registerDate: "",
      // endDate: "",
      // dur: "",
      // dob: "",
      // age: "",
      // address: "",
      phone: "",
      room:"",
      broom:"",
      mail: [], // ✅ Now it's an array
      // department: "",
      // designation: "",
      // education: "",
      // jObroll: "",
      imageUrl: "",
    });

    // Refresh data and show table
    fetchEmployees();
    setShowTable(true);
  } catch (error) {
    console.error("Error in handleRegister:", error);
    alert("Something went wrong while saving the data.");
  }
};


  const handleDelete = async (id) => {
    await deleteDoc(doc(db, "employees", id));
    fetchEmployees();
  };

  const handleEdit = (emp) => {
    setFormData(emp);
    setEditId(emp.id);
  };

  const exportToExcel = () => {
  const exportData = employees.map((emp, i) => ({
    No: i + 1,
    Name: emp.name,
    "HID": emp.hid,
    // "Register Date": emp.registerDate,
    // "End Date": emp.endDate,
    // Duration: emp.dur,
    // DOB: emp.dob,
    // Age: emp.age,
    // Address: emp.address,    
    Phone: emp.phone,
    Rooms:emp.room,
    BRooms:emp.broom,
    Mail:emp.mail,
    // Department: emp.department,
    // Designation: emp.designation,
    // Education: emp.education,
    // Job_Roll: emp.jObroll,
    "Image URL": emp.imageUrl || "N/A"
  }));

  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Employees");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(data, "Hotel.xlsx");
};


 const exportToPDF = () => {
  const docPDF = new jsPDF();
  docPDF.text("Hotel List", 14, 10);

  autoTable(docPDF, {
    head: [
      ["No", "HID","Name","Phone", "Rooms","BRooms"]
    ],
    body: employees.map((emp, i) => [
      i + 1,
      emp.hid,
      emp.name,
      // emp.epfOrPid,
      // emp.registerDate,
      // emp.endDate,
      // emp.dur,
      // emp.dob,
      // emp.age,
      // emp.address,
      emp.phone,
      emp.room,
      emp.broom,
      emp.mail,
      // emp.department,
      // emp.designation,
      // emp.education,
      // emp.jObroll,
      // emp.imageUrl || "N/A"
    ]),
  });

  docPDF.save("Hotel.pdf");
};

 // 1. Filter by search input
const filteredEmployees = employees.filter((emp) =>
  emp.name.toLowerCase().includes(search.toLowerCase()) ||
  emp.hid.toLowerCase().includes(search.toLowerCase())
);

// 2. Sort filtered data alphabetically by name
const sortedEmployees = [...filteredEmployees].sort((a, b) =>
  a.name.localeCompare(b.name)
);

// 3. Paginate the sorted, filtered list
const paginatedEmployees = sortedEmployees.slice(startIndex, endIndex);

// 4. Update total pages based on filtered results
const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);

const handleAddEmail = () => {
  const email = newEmail.trim().toLowerCase();

  if (!email || !email.includes("@")) {
    alert("Please enter a valid email.");
    return;
  }

  if (formData.mail.includes(email)) {
    alert("Email already added.");
    return;
  }

  setFormData((prev) => ({
    ...prev,
    mail: [...prev.mail, email],
  }));
  setNewEmail(""); // Clear input
};

const handleRemoveEmail = (emailToRemove) => {
  setFormData((prev) => ({
    ...prev,
    mail: prev.mail.filter((email) => email !== emailToRemove),
  }));
};



  return (
    <div className="register-container">
      <h2>{editId ? "Update Employee" : "Register New User"}</h2>
      <form className="register-form" onSubmit={handleRegister}>
        <input type="text" name="name" placeholder="Hotel Name" value={formData.name} onChange={handleInputChange} required />
        <input type="text" name="hid" placeholder="Hotel-ID" value={formData.hid} onChange={handleInputChange} required />
        {/* <label htmlFor="registerDate">Register Date</label> <input type="date" name="registerDate" placeholder="Register Date" value={formData.registerDate} onChange={handleInputChange} required />
        <label htmlFor="endDate">End Date</label> <input type="date" name="endDate" value={formData.endDate} onChange={handleInputChange} />
        <input type="text" name="dur" placeholder="Duration" value={formData.dur} readOnly />
        <label htmlFor="bod">BOD</label> <input type="date" name="dob" value={formData.dob} onChange={handleInputChange} required />
        <input type="number" name="age" placeholder="Age" value={formData.age} readOnly />
        <input type="text" name="address" placeholder="Address" value={formData.address} onChange={handleInputChange} required /> */}
        <input type="tel" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleInputChange} />
        <input type="number" name="room" placeholder="Total Hotel Rooms" value={formData.room} onChange={handleInputChange}  />
        <input type="number" name="broom" placeholder="Total Bathrooms" value={formData.broom} onChange={handleInputChange}  />
       <div className="email-input-wrapper">
          <label>User Emails</label>
          <div className="email-input-row">
            <input
              type="email"
              placeholder="Enter email and click Add"
              value={newEmail}
              onChange={(e) => setNewEmail(e.target.value)}
            />
           <button
  type="button"
  onClick={handleAddEmail}
  className="w-full sm:w-auto px-5 py-2 text-sm sm:text-base bg-blue-600 text-white rounded-md hover:bg-blue-700 transition duration-200"
>
  Add
</button>

          </div>

          <div className="email-chip-container">
            {formData.mail.map((email, index) => (
              <div className="email-chip" key={index}>
                {email}
                <button type="button" onClick={() => handleRemoveEmail(email)}>
                  ×
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* <input type="text" name="education" placeholder="Education" value={formData.education} onChange={handleInputChange} required />
        <input type="text" name="jObroll" placeholder="Job_Roll" value={formData.jObroll} onChange={handleInputChange} /> */}

        {/* <label htmlFor="image">Upload Photo</label>
        <input type="file" accept="image/*" onChange={handleImageUpload} />
        {formData.imageUrl && <img src={formData.imageUrl} alt="Employee" style={{ width: "60px", height: "60px", objectFit: "cover", borderRadius: "6px", marginTop: "5px" }} />} */}

        <div className="buttons">
          <button type="submit">{editId ? "Update" : "Register"}</button>
          <button type="button" onClick={() => setShowTable(!showTable)}>
            {showTable ? "Hide Details" : "View Details"}
          </button>
        </div>
      </form>

      {showTable && (
        <>
          <div className="table-actions">
            <input
              type="text"
              placeholder="Search by Name or HID"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <button onClick={exportToExcel}>Export Excel</button>
            <button onClick={exportToPDF}>Export PDF</button>
          </div>

          <div className="table-wrapper">
        
         <table className="employee-table">
  <thead>
    <tr>
      <th>No</th> {/* New column */}
      <th>Name</th>
      <th>Hotel-ID</th>
      {/* <th>EPF/PID</th>
      <th>Reg Date</th>
      <th>End Date</th>
      <th>Duration</th>
      <th>DOB</th>
      <th>Age</th>
      <th>Address</th> */}
      <th>Phone</th>
      <th>Total Rooms</th>
      <th>Total Bath Rooms</th>
      <th>User Mails</th>
      {/* <th>Education</th>
      <th>Job_Roll</th> */}
      {/* <th>Photo</th> */}
      <th>Actions</th>

    </tr>
  </thead>
    <tbody>
      {paginatedEmployees.map((emp, i) => {
        // const today = new Date();
        // const dobDate = new Date(emp.dob);

        // const isBirthdayToday =
        //   dobDate.getDate() === today.getDate() &&
        //   dobDate.getMonth() === today.getMonth();

        // // Show alert only if birthday today AND not already shown
        // if (
        //   isBirthdayToday &&
        //   !shownBirthdays.includes(emp.epfOrPid)
        // ) {
        //   alert(`🎉 Today is ${emp.name} (PID: ${emp.epfOrPid})'s birthday!`);
        //   setShownBirthdays(prev => [...prev, emp.epfOrPid]);
        // }

        return (
          <tr key={emp.id}>
            <td data-label="No">{(currentPage - 1) * itemsPerPage + i + 1}</td>
            <td data-label="Name">{emp.name}</td>
            <td data-label="HID">{emp.hid}</td>
            {/* <td data-label="EPF/PID">{emp.epfOrPid}</td>
            <td data-label="Reg Date">{emp.registerDate}</td>
            <td data-label="End Date">{emp.endDate}</td>
            <td data-label="Duration">{emp.dur}</td>
            <td data-label="DOB">{emp.dob}</td>
            <td data-label="Age">{emp.age}</td>
            <td data-label="Address">{emp.address}</td> */}
            <td data-label="Phone">{emp.phone}</td>
            <td data-label="Rooms">{emp.room}</td>
            <td data-label="BRooms">{emp.broom}</td>
            <td data-label="BRooms">{emp.mail}</td>
            {/* <td data-label="Education">{emp.education}</td>
            <td data-label="Job_Roll">{emp.jObroll}</td> */}
            {/* <td data-label="Photo">
              {emp.imageUrl ? (
                <img
                  src={emp.imageUrl}
                  alt="Emp"
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "4px",
                    objectFit: "cover",
                  }}
                />
              ) : (
                "No image"
              )}
            </td> */}
            <td data-label="Actions">
              <button onClick={() => handleEdit(emp)}>Edit</button>
              <button
                onClick={() => {
                  if (window.confirm("Are you sure you want to delete this employee?")) {
                    handleDelete(emp.id);
                  }
                }}
              >
                Delete
              </button>
            </td>
          </tr>
        );
      })}

    </tbody>
</table>

          </div>

          <div className="pagination">
            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i + 1}
                className={currentPage === i + 1 ? "active" : ""}
                onClick={() => setCurrentPage(i + 1)}
              >
                {i + 1}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Register;
